export const SIDE_EFFECT = 'SIDE_EFFECT';
export const REDIRECT = 'REDIRECT';

const isValid = ({type}) => Array.isArray(callbacks[type]);

const callbacks = {
  [SIDE_EFFECT]: [],
  [REDIRECT]: []
};

// condition determines whether to execute handler
const addCallback = ({type, condition, handler}) => callbacks[type].push({condition, handler});

// pop one or more states
export const popState = (num) => window.history.go(num ? -num : -1);

// approach for srp -- give option prefer sideeffects over redirects
// sideeffects must return true {preventRedirect} to prevent redirect
export const onPopState = ({type, condition, handler}) => {
  if (isValid({type}))
    addCallback({type, condition, handler});
};

window.addEventListener("popstate", ({state}) => {
  let preventRedirect = false;
  callbacks[SIDE_EFFECT].forEach(({condition, handler}) => {
    // side effects call handlers
    // if handler returns {preventRedirect}
    // no redirect handlers are executed
    if (condition(state || {})) {
      let result = handler(state) || {};
      preventRedirect = preventRedirect || result.preventRedirect;
    }
  });

  if (preventRedirect)
    return;
  else
    callbacks[REDIRECT].forEach(({condition, handler}) => {
      if (condition(state || {})) {
        window.location.href = handler(state);
      }
    });
});



// WEBPACK FOOTER //
// ./shared_non_critical/events/popstate.js